/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VendorsRouteImport } from './routes/vendors'
import { Route as UsersRouteImport } from './routes/users'
import { Route as RfqRouteImport } from './routes/rfq'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as PurchaseRequestsRouteImport } from './routes/purchase-requests'
import { Route as PurchaseOrdersRouteImport } from './routes/purchase-orders'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ItemMasterRouteImport } from './routes/item-master'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as GrnRouteImport } from './routes/grn'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as ExceptionsRouteImport } from './routes/exceptions'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as AuditLogsRouteImport } from './routes/audit-logs'
import { Route as ApprovalsRouteImport } from './routes/approvals'
import { Route as ApprovalRulesRouteImport } from './routes/approval-rules'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as VendorsNewRouteImport } from './routes/vendors.new'
import { Route as VendorsIdRouteImport } from './routes/vendors.$id'
import { Route as SettingsRolesRouteImport } from './routes/settings.roles'
import { Route as SettingsMatchPolicyRouteImport } from './routes/settings.match-policy'
import { Route as SettingsLocationsRouteImport } from './routes/settings.locations'
import { Route as SettingsEmailRouteImport } from './routes/settings.email'
import { Route as SettingsDepartmentsRouteImport } from './routes/settings.departments'
import { Route as SettingsApprovalsRouteImport } from './routes/settings.approvals'
import { Route as RfqNewRouteImport } from './routes/rfq_.new'
import { Route as RfqBuildRouteImport } from './routes/rfq_.build'
import { Route as RfqIdRouteImport } from './routes/rfq.$id'
import { Route as PurchaseRequestsNewRouteImport } from './routes/purchase-requests.new'
import { Route as PurchaseRequestsIdRouteImport } from './routes/purchase-requests.$id'
import { Route as PurchaseOrdersBuildRouteImport } from './routes/purchase-orders_.build'
import { Route as PurchaseOrdersIdRouteImport } from './routes/purchase-orders.$id'
import { Route as InvoicesPaymentQueueRouteImport } from './routes/invoices_.payment-queue'
import { Route as InvoicesNewRouteImport } from './routes/invoices_.new'
import { Route as InvoicesFromGrnsRouteImport } from './routes/invoices_.from-grns'
import { Route as InvoicesIdRouteImport } from './routes/invoices_.$id'
import { Route as GrnBuildRouteImport } from './routes/grn_.build'
import { Route as GrnIdRouteImport } from './routes/grn.$id'
import { Route as RfqIdCompareRouteImport } from './routes/rfq.$id.compare'
import { Route as PurchaseRequestsIdEditRouteImport } from './routes/purchase-requests.$id.edit'
import { Route as GrnReceivePoIdRouteImport } from './routes/grn.receive.$poId'
import { Route as RfqIdQuotesNewRouteImport } from './routes/rfq.$id.quotes.new'

const VendorsRoute = VendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const RfqRoute = RfqRouteImport.update({
  id: '/rfq',
  path: '/rfq',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const PurchaseRequestsRoute = PurchaseRequestsRouteImport.update({
  id: '/purchase-requests',
  path: '/purchase-requests',
  getParentRoute: () => rootRouteImport,
} as any)
const PurchaseOrdersRoute = PurchaseOrdersRouteImport.update({
  id: '/purchase-orders',
  path: '/purchase-orders',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ItemMasterRoute = ItemMasterRouteImport.update({
  id: '/item-master',
  path: '/item-master',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const GrnRoute = GrnRouteImport.update({
  id: '/grn',
  path: '/grn',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const ExceptionsRoute = ExceptionsRouteImport.update({
  id: '/exceptions',
  path: '/exceptions',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogsRoute = AuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalsRoute = ApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const ApprovalRulesRoute = ApprovalRulesRouteImport.update({
  id: '/approval-rules',
  path: '/approval-rules',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const VendorsNewRoute = VendorsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => VendorsRoute,
} as any)
const VendorsIdRoute = VendorsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => VendorsRoute,
} as any)
const SettingsRolesRoute = SettingsRolesRouteImport.update({
  id: '/settings/roles',
  path: '/settings/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMatchPolicyRoute = SettingsMatchPolicyRouteImport.update({
  id: '/settings/match-policy',
  path: '/settings/match-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLocationsRoute = SettingsLocationsRouteImport.update({
  id: '/settings/locations',
  path: '/settings/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsEmailRoute = SettingsEmailRouteImport.update({
  id: '/settings/email',
  path: '/settings/email',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsDepartmentsRoute = SettingsDepartmentsRouteImport.update({
  id: '/settings/departments',
  path: '/settings/departments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsApprovalsRoute = SettingsApprovalsRouteImport.update({
  id: '/settings/approvals',
  path: '/settings/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const RfqNewRoute = RfqNewRouteImport.update({
  id: '/rfq_/new',
  path: '/rfq/new',
  getParentRoute: () => rootRouteImport,
} as any)
const RfqBuildRoute = RfqBuildRouteImport.update({
  id: '/rfq_/build',
  path: '/rfq/build',
  getParentRoute: () => rootRouteImport,
} as any)
const RfqIdRoute = RfqIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => RfqRoute,
} as any)
const PurchaseRequestsNewRoute = PurchaseRequestsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => PurchaseRequestsRoute,
} as any)
const PurchaseRequestsIdRoute = PurchaseRequestsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PurchaseRequestsRoute,
} as any)
const PurchaseOrdersBuildRoute = PurchaseOrdersBuildRouteImport.update({
  id: '/purchase-orders_/build',
  path: '/purchase-orders/build',
  getParentRoute: () => rootRouteImport,
} as any)
const PurchaseOrdersIdRoute = PurchaseOrdersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PurchaseOrdersRoute,
} as any)
const InvoicesPaymentQueueRoute = InvoicesPaymentQueueRouteImport.update({
  id: '/invoices_/payment-queue',
  path: '/invoices/payment-queue',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesNewRoute = InvoicesNewRouteImport.update({
  id: '/invoices_/new',
  path: '/invoices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesFromGrnsRoute = InvoicesFromGrnsRouteImport.update({
  id: '/invoices_/from-grns',
  path: '/invoices/from-grns',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/invoices_/$id',
  path: '/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const GrnBuildRoute = GrnBuildRouteImport.update({
  id: '/grn_/build',
  path: '/grn/build',
  getParentRoute: () => rootRouteImport,
} as any)
const GrnIdRoute = GrnIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => GrnRoute,
} as any)
const RfqIdCompareRoute = RfqIdCompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => RfqIdRoute,
} as any)
const PurchaseRequestsIdEditRoute = PurchaseRequestsIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => PurchaseRequestsIdRoute,
} as any)
const GrnReceivePoIdRoute = GrnReceivePoIdRouteImport.update({
  id: '/receive/$poId',
  path: '/receive/$poId',
  getParentRoute: () => GrnRoute,
} as any)
const RfqIdQuotesNewRoute = RfqIdQuotesNewRouteImport.update({
  id: '/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => RfqIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/approval-rules': typeof ApprovalRulesRoute
  '/approvals': typeof ApprovalsRoute
  '/audit-logs': typeof AuditLogsRoute
  '/change-password': typeof ChangePasswordRoute
  '/exceptions': typeof ExceptionsRoute
  '/finance': typeof FinanceRoute
  '/grn': typeof GrnRouteWithChildren
  '/invoices': typeof InvoicesRoute
  '/item-master': typeof ItemMasterRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/purchase-orders': typeof PurchaseOrdersRouteWithChildren
  '/purchase-requests': typeof PurchaseRequestsRouteWithChildren
  '/reports': typeof ReportsRoute
  '/rfq': typeof RfqRouteWithChildren
  '/users': typeof UsersRoute
  '/vendors': typeof VendorsRouteWithChildren
  '/grn/$id': typeof GrnIdRoute
  '/grn/build': typeof GrnBuildRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/from-grns': typeof InvoicesFromGrnsRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/invoices/payment-queue': typeof InvoicesPaymentQueueRoute
  '/purchase-orders/$id': typeof PurchaseOrdersIdRoute
  '/purchase-orders/build': typeof PurchaseOrdersBuildRoute
  '/purchase-requests/$id': typeof PurchaseRequestsIdRouteWithChildren
  '/purchase-requests/new': typeof PurchaseRequestsNewRoute
  '/rfq/$id': typeof RfqIdRouteWithChildren
  '/rfq/build': typeof RfqBuildRoute
  '/rfq/new': typeof RfqNewRoute
  '/settings/approvals': typeof SettingsApprovalsRoute
  '/settings/departments': typeof SettingsDepartmentsRoute
  '/settings/email': typeof SettingsEmailRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/match-policy': typeof SettingsMatchPolicyRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/vendors/$id': typeof VendorsIdRoute
  '/vendors/new': typeof VendorsNewRoute
  '/settings/': typeof SettingsIndexRoute
  '/grn/receive/$poId': typeof GrnReceivePoIdRoute
  '/purchase-requests/$id/edit': typeof PurchaseRequestsIdEditRoute
  '/rfq/$id/compare': typeof RfqIdCompareRoute
  '/rfq/$id/quotes/new': typeof RfqIdQuotesNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/approval-rules': typeof ApprovalRulesRoute
  '/approvals': typeof ApprovalsRoute
  '/audit-logs': typeof AuditLogsRoute
  '/change-password': typeof ChangePasswordRoute
  '/exceptions': typeof ExceptionsRoute
  '/finance': typeof FinanceRoute
  '/grn': typeof GrnRouteWithChildren
  '/invoices': typeof InvoicesRoute
  '/item-master': typeof ItemMasterRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/purchase-orders': typeof PurchaseOrdersRouteWithChildren
  '/purchase-requests': typeof PurchaseRequestsRouteWithChildren
  '/reports': typeof ReportsRoute
  '/rfq': typeof RfqRouteWithChildren
  '/users': typeof UsersRoute
  '/vendors': typeof VendorsRouteWithChildren
  '/grn/$id': typeof GrnIdRoute
  '/grn/build': typeof GrnBuildRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/from-grns': typeof InvoicesFromGrnsRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/invoices/payment-queue': typeof InvoicesPaymentQueueRoute
  '/purchase-orders/$id': typeof PurchaseOrdersIdRoute
  '/purchase-orders/build': typeof PurchaseOrdersBuildRoute
  '/purchase-requests/$id': typeof PurchaseRequestsIdRouteWithChildren
  '/purchase-requests/new': typeof PurchaseRequestsNewRoute
  '/rfq/$id': typeof RfqIdRouteWithChildren
  '/rfq/build': typeof RfqBuildRoute
  '/rfq/new': typeof RfqNewRoute
  '/settings/approvals': typeof SettingsApprovalsRoute
  '/settings/departments': typeof SettingsDepartmentsRoute
  '/settings/email': typeof SettingsEmailRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/match-policy': typeof SettingsMatchPolicyRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/vendors/$id': typeof VendorsIdRoute
  '/vendors/new': typeof VendorsNewRoute
  '/settings': typeof SettingsIndexRoute
  '/grn/receive/$poId': typeof GrnReceivePoIdRoute
  '/purchase-requests/$id/edit': typeof PurchaseRequestsIdEditRoute
  '/rfq/$id/compare': typeof RfqIdCompareRoute
  '/rfq/$id/quotes/new': typeof RfqIdQuotesNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/approval-rules': typeof ApprovalRulesRoute
  '/approvals': typeof ApprovalsRoute
  '/audit-logs': typeof AuditLogsRoute
  '/change-password': typeof ChangePasswordRoute
  '/exceptions': typeof ExceptionsRoute
  '/finance': typeof FinanceRoute
  '/grn': typeof GrnRouteWithChildren
  '/invoices': typeof InvoicesRoute
  '/item-master': typeof ItemMasterRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/purchase-orders': typeof PurchaseOrdersRouteWithChildren
  '/purchase-requests': typeof PurchaseRequestsRouteWithChildren
  '/reports': typeof ReportsRoute
  '/rfq': typeof RfqRouteWithChildren
  '/users': typeof UsersRoute
  '/vendors': typeof VendorsRouteWithChildren
  '/grn/$id': typeof GrnIdRoute
  '/grn_/build': typeof GrnBuildRoute
  '/invoices_/$id': typeof InvoicesIdRoute
  '/invoices_/from-grns': typeof InvoicesFromGrnsRoute
  '/invoices_/new': typeof InvoicesNewRoute
  '/invoices_/payment-queue': typeof InvoicesPaymentQueueRoute
  '/purchase-orders/$id': typeof PurchaseOrdersIdRoute
  '/purchase-orders_/build': typeof PurchaseOrdersBuildRoute
  '/purchase-requests/$id': typeof PurchaseRequestsIdRouteWithChildren
  '/purchase-requests/new': typeof PurchaseRequestsNewRoute
  '/rfq/$id': typeof RfqIdRouteWithChildren
  '/rfq_/build': typeof RfqBuildRoute
  '/rfq_/new': typeof RfqNewRoute
  '/settings/approvals': typeof SettingsApprovalsRoute
  '/settings/departments': typeof SettingsDepartmentsRoute
  '/settings/email': typeof SettingsEmailRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/match-policy': typeof SettingsMatchPolicyRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/vendors/$id': typeof VendorsIdRoute
  '/vendors/new': typeof VendorsNewRoute
  '/settings/': typeof SettingsIndexRoute
  '/grn/receive/$poId': typeof GrnReceivePoIdRoute
  '/purchase-requests/$id/edit': typeof PurchaseRequestsIdEditRoute
  '/rfq/$id/compare': typeof RfqIdCompareRoute
  '/rfq/$id/quotes/new': typeof RfqIdQuotesNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/approval-rules'
    | '/approvals'
    | '/audit-logs'
    | '/change-password'
    | '/exceptions'
    | '/finance'
    | '/grn'
    | '/invoices'
    | '/item-master'
    | '/login'
    | '/notifications'
    | '/purchase-orders'
    | '/purchase-requests'
    | '/reports'
    | '/rfq'
    | '/users'
    | '/vendors'
    | '/grn/$id'
    | '/grn/build'
    | '/invoices/$id'
    | '/invoices/from-grns'
    | '/invoices/new'
    | '/invoices/payment-queue'
    | '/purchase-orders/$id'
    | '/purchase-orders/build'
    | '/purchase-requests/$id'
    | '/purchase-requests/new'
    | '/rfq/$id'
    | '/rfq/build'
    | '/rfq/new'
    | '/settings/approvals'
    | '/settings/departments'
    | '/settings/email'
    | '/settings/locations'
    | '/settings/match-policy'
    | '/settings/roles'
    | '/vendors/$id'
    | '/vendors/new'
    | '/settings/'
    | '/grn/receive/$poId'
    | '/purchase-requests/$id/edit'
    | '/rfq/$id/compare'
    | '/rfq/$id/quotes/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/approval-rules'
    | '/approvals'
    | '/audit-logs'
    | '/change-password'
    | '/exceptions'
    | '/finance'
    | '/grn'
    | '/invoices'
    | '/item-master'
    | '/login'
    | '/notifications'
    | '/purchase-orders'
    | '/purchase-requests'
    | '/reports'
    | '/rfq'
    | '/users'
    | '/vendors'
    | '/grn/$id'
    | '/grn/build'
    | '/invoices/$id'
    | '/invoices/from-grns'
    | '/invoices/new'
    | '/invoices/payment-queue'
    | '/purchase-orders/$id'
    | '/purchase-orders/build'
    | '/purchase-requests/$id'
    | '/purchase-requests/new'
    | '/rfq/$id'
    | '/rfq/build'
    | '/rfq/new'
    | '/settings/approvals'
    | '/settings/departments'
    | '/settings/email'
    | '/settings/locations'
    | '/settings/match-policy'
    | '/settings/roles'
    | '/vendors/$id'
    | '/vendors/new'
    | '/settings'
    | '/grn/receive/$poId'
    | '/purchase-requests/$id/edit'
    | '/rfq/$id/compare'
    | '/rfq/$id/quotes/new'
  id:
    | '__root__'
    | '/'
    | '/approval-rules'
    | '/approvals'
    | '/audit-logs'
    | '/change-password'
    | '/exceptions'
    | '/finance'
    | '/grn'
    | '/invoices'
    | '/item-master'
    | '/login'
    | '/notifications'
    | '/purchase-orders'
    | '/purchase-requests'
    | '/reports'
    | '/rfq'
    | '/users'
    | '/vendors'
    | '/grn/$id'
    | '/grn_/build'
    | '/invoices_/$id'
    | '/invoices_/from-grns'
    | '/invoices_/new'
    | '/invoices_/payment-queue'
    | '/purchase-orders/$id'
    | '/purchase-orders_/build'
    | '/purchase-requests/$id'
    | '/purchase-requests/new'
    | '/rfq/$id'
    | '/rfq_/build'
    | '/rfq_/new'
    | '/settings/approvals'
    | '/settings/departments'
    | '/settings/email'
    | '/settings/locations'
    | '/settings/match-policy'
    | '/settings/roles'
    | '/vendors/$id'
    | '/vendors/new'
    | '/settings/'
    | '/grn/receive/$poId'
    | '/purchase-requests/$id/edit'
    | '/rfq/$id/compare'
    | '/rfq/$id/quotes/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApprovalRulesRoute: typeof ApprovalRulesRoute
  ApprovalsRoute: typeof ApprovalsRoute
  AuditLogsRoute: typeof AuditLogsRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  ExceptionsRoute: typeof ExceptionsRoute
  FinanceRoute: typeof FinanceRoute
  GrnRoute: typeof GrnRouteWithChildren
  InvoicesRoute: typeof InvoicesRoute
  ItemMasterRoute: typeof ItemMasterRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  PurchaseOrdersRoute: typeof PurchaseOrdersRouteWithChildren
  PurchaseRequestsRoute: typeof PurchaseRequestsRouteWithChildren
  ReportsRoute: typeof ReportsRoute
  RfqRoute: typeof RfqRouteWithChildren
  UsersRoute: typeof UsersRoute
  VendorsRoute: typeof VendorsRouteWithChildren
  GrnBuildRoute: typeof GrnBuildRoute
  InvoicesIdRoute: typeof InvoicesIdRoute
  InvoicesFromGrnsRoute: typeof InvoicesFromGrnsRoute
  InvoicesNewRoute: typeof InvoicesNewRoute
  InvoicesPaymentQueueRoute: typeof InvoicesPaymentQueueRoute
  PurchaseOrdersBuildRoute: typeof PurchaseOrdersBuildRoute
  RfqBuildRoute: typeof RfqBuildRoute
  RfqNewRoute: typeof RfqNewRoute
  SettingsApprovalsRoute: typeof SettingsApprovalsRoute
  SettingsDepartmentsRoute: typeof SettingsDepartmentsRoute
  SettingsEmailRoute: typeof SettingsEmailRoute
  SettingsLocationsRoute: typeof SettingsLocationsRoute
  SettingsMatchPolicyRoute: typeof SettingsMatchPolicyRoute
  SettingsRolesRoute: typeof SettingsRolesRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vendors': {
      id: '/vendors'
      path: '/vendors'
      fullPath: '/vendors'
      preLoaderRoute: typeof VendorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rfq': {
      id: '/rfq'
      path: '/rfq'
      fullPath: '/rfq'
      preLoaderRoute: typeof RfqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/purchase-requests': {
      id: '/purchase-requests'
      path: '/purchase-requests'
      fullPath: '/purchase-requests'
      preLoaderRoute: typeof PurchaseRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/purchase-orders': {
      id: '/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/purchase-orders'
      preLoaderRoute: typeof PurchaseOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/item-master': {
      id: '/item-master'
      path: '/item-master'
      fullPath: '/item-master'
      preLoaderRoute: typeof ItemMasterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grn': {
      id: '/grn'
      path: '/grn'
      fullPath: '/grn'
      preLoaderRoute: typeof GrnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exceptions': {
      id: '/exceptions'
      path: '/exceptions'
      fullPath: '/exceptions'
      preLoaderRoute: typeof ExceptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-logs': {
      id: '/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuditLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals': {
      id: '/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approval-rules': {
      id: '/approval-rules'
      path: '/approval-rules'
      fullPath: '/approval-rules'
      preLoaderRoute: typeof ApprovalRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendors/new': {
      id: '/vendors/new'
      path: '/new'
      fullPath: '/vendors/new'
      preLoaderRoute: typeof VendorsNewRouteImport
      parentRoute: typeof VendorsRoute
    }
    '/vendors/$id': {
      id: '/vendors/$id'
      path: '/$id'
      fullPath: '/vendors/$id'
      preLoaderRoute: typeof VendorsIdRouteImport
      parentRoute: typeof VendorsRoute
    }
    '/settings/roles': {
      id: '/settings/roles'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof SettingsRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/match-policy': {
      id: '/settings/match-policy'
      path: '/settings/match-policy'
      fullPath: '/settings/match-policy'
      preLoaderRoute: typeof SettingsMatchPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/locations': {
      id: '/settings/locations'
      path: '/settings/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof SettingsLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/email': {
      id: '/settings/email'
      path: '/settings/email'
      fullPath: '/settings/email'
      preLoaderRoute: typeof SettingsEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/departments': {
      id: '/settings/departments'
      path: '/settings/departments'
      fullPath: '/settings/departments'
      preLoaderRoute: typeof SettingsDepartmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/approvals': {
      id: '/settings/approvals'
      path: '/settings/approvals'
      fullPath: '/settings/approvals'
      preLoaderRoute: typeof SettingsApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rfq_/new': {
      id: '/rfq_/new'
      path: '/rfq/new'
      fullPath: '/rfq/new'
      preLoaderRoute: typeof RfqNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rfq_/build': {
      id: '/rfq_/build'
      path: '/rfq/build'
      fullPath: '/rfq/build'
      preLoaderRoute: typeof RfqBuildRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rfq/$id': {
      id: '/rfq/$id'
      path: '/$id'
      fullPath: '/rfq/$id'
      preLoaderRoute: typeof RfqIdRouteImport
      parentRoute: typeof RfqRoute
    }
    '/purchase-requests/new': {
      id: '/purchase-requests/new'
      path: '/new'
      fullPath: '/purchase-requests/new'
      preLoaderRoute: typeof PurchaseRequestsNewRouteImport
      parentRoute: typeof PurchaseRequestsRoute
    }
    '/purchase-requests/$id': {
      id: '/purchase-requests/$id'
      path: '/$id'
      fullPath: '/purchase-requests/$id'
      preLoaderRoute: typeof PurchaseRequestsIdRouteImport
      parentRoute: typeof PurchaseRequestsRoute
    }
    '/purchase-orders_/build': {
      id: '/purchase-orders_/build'
      path: '/purchase-orders/build'
      fullPath: '/purchase-orders/build'
      preLoaderRoute: typeof PurchaseOrdersBuildRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/purchase-orders/$id': {
      id: '/purchase-orders/$id'
      path: '/$id'
      fullPath: '/purchase-orders/$id'
      preLoaderRoute: typeof PurchaseOrdersIdRouteImport
      parentRoute: typeof PurchaseOrdersRoute
    }
    '/invoices_/payment-queue': {
      id: '/invoices_/payment-queue'
      path: '/invoices/payment-queue'
      fullPath: '/invoices/payment-queue'
      preLoaderRoute: typeof InvoicesPaymentQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/new': {
      id: '/invoices_/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof InvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/from-grns': {
      id: '/invoices_/from-grns'
      path: '/invoices/from-grns'
      fullPath: '/invoices/from-grns'
      preLoaderRoute: typeof InvoicesFromGrnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices_/$id': {
      id: '/invoices_/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof InvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grn_/build': {
      id: '/grn_/build'
      path: '/grn/build'
      fullPath: '/grn/build'
      preLoaderRoute: typeof GrnBuildRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grn/$id': {
      id: '/grn/$id'
      path: '/$id'
      fullPath: '/grn/$id'
      preLoaderRoute: typeof GrnIdRouteImport
      parentRoute: typeof GrnRoute
    }
    '/rfq/$id/compare': {
      id: '/rfq/$id/compare'
      path: '/compare'
      fullPath: '/rfq/$id/compare'
      preLoaderRoute: typeof RfqIdCompareRouteImport
      parentRoute: typeof RfqIdRoute
    }
    '/purchase-requests/$id/edit': {
      id: '/purchase-requests/$id/edit'
      path: '/edit'
      fullPath: '/purchase-requests/$id/edit'
      preLoaderRoute: typeof PurchaseRequestsIdEditRouteImport
      parentRoute: typeof PurchaseRequestsIdRoute
    }
    '/grn/receive/$poId': {
      id: '/grn/receive/$poId'
      path: '/receive/$poId'
      fullPath: '/grn/receive/$poId'
      preLoaderRoute: typeof GrnReceivePoIdRouteImport
      parentRoute: typeof GrnRoute
    }
    '/rfq/$id/quotes/new': {
      id: '/rfq/$id/quotes/new'
      path: '/quotes/new'
      fullPath: '/rfq/$id/quotes/new'
      preLoaderRoute: typeof RfqIdQuotesNewRouteImport
      parentRoute: typeof RfqIdRoute
    }
  }
}

interface GrnRouteChildren {
  GrnIdRoute: typeof GrnIdRoute
  GrnReceivePoIdRoute: typeof GrnReceivePoIdRoute
}

const GrnRouteChildren: GrnRouteChildren = {
  GrnIdRoute: GrnIdRoute,
  GrnReceivePoIdRoute: GrnReceivePoIdRoute,
}

const GrnRouteWithChildren = GrnRoute._addFileChildren(GrnRouteChildren)

interface PurchaseOrdersRouteChildren {
  PurchaseOrdersIdRoute: typeof PurchaseOrdersIdRoute
}

const PurchaseOrdersRouteChildren: PurchaseOrdersRouteChildren = {
  PurchaseOrdersIdRoute: PurchaseOrdersIdRoute,
}

const PurchaseOrdersRouteWithChildren = PurchaseOrdersRoute._addFileChildren(
  PurchaseOrdersRouteChildren,
)

interface PurchaseRequestsIdRouteChildren {
  PurchaseRequestsIdEditRoute: typeof PurchaseRequestsIdEditRoute
}

const PurchaseRequestsIdRouteChildren: PurchaseRequestsIdRouteChildren = {
  PurchaseRequestsIdEditRoute: PurchaseRequestsIdEditRoute,
}

const PurchaseRequestsIdRouteWithChildren =
  PurchaseRequestsIdRoute._addFileChildren(PurchaseRequestsIdRouteChildren)

interface PurchaseRequestsRouteChildren {
  PurchaseRequestsIdRoute: typeof PurchaseRequestsIdRouteWithChildren
  PurchaseRequestsNewRoute: typeof PurchaseRequestsNewRoute
}

const PurchaseRequestsRouteChildren: PurchaseRequestsRouteChildren = {
  PurchaseRequestsIdRoute: PurchaseRequestsIdRouteWithChildren,
  PurchaseRequestsNewRoute: PurchaseRequestsNewRoute,
}

const PurchaseRequestsRouteWithChildren =
  PurchaseRequestsRoute._addFileChildren(PurchaseRequestsRouteChildren)

interface RfqIdRouteChildren {
  RfqIdCompareRoute: typeof RfqIdCompareRoute
  RfqIdQuotesNewRoute: typeof RfqIdQuotesNewRoute
}

const RfqIdRouteChildren: RfqIdRouteChildren = {
  RfqIdCompareRoute: RfqIdCompareRoute,
  RfqIdQuotesNewRoute: RfqIdQuotesNewRoute,
}

const RfqIdRouteWithChildren = RfqIdRoute._addFileChildren(RfqIdRouteChildren)

interface RfqRouteChildren {
  RfqIdRoute: typeof RfqIdRouteWithChildren
}

const RfqRouteChildren: RfqRouteChildren = {
  RfqIdRoute: RfqIdRouteWithChildren,
}

const RfqRouteWithChildren = RfqRoute._addFileChildren(RfqRouteChildren)

interface VendorsRouteChildren {
  VendorsIdRoute: typeof VendorsIdRoute
  VendorsNewRoute: typeof VendorsNewRoute
}

const VendorsRouteChildren: VendorsRouteChildren = {
  VendorsIdRoute: VendorsIdRoute,
  VendorsNewRoute: VendorsNewRoute,
}

const VendorsRouteWithChildren =
  VendorsRoute._addFileChildren(VendorsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApprovalRulesRoute: ApprovalRulesRoute,
  ApprovalsRoute: ApprovalsRoute,
  AuditLogsRoute: AuditLogsRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  ExceptionsRoute: ExceptionsRoute,
  FinanceRoute: FinanceRoute,
  GrnRoute: GrnRouteWithChildren,
  InvoicesRoute: InvoicesRoute,
  ItemMasterRoute: ItemMasterRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  PurchaseOrdersRoute: PurchaseOrdersRouteWithChildren,
  PurchaseRequestsRoute: PurchaseRequestsRouteWithChildren,
  ReportsRoute: ReportsRoute,
  RfqRoute: RfqRouteWithChildren,
  UsersRoute: UsersRoute,
  VendorsRoute: VendorsRouteWithChildren,
  GrnBuildRoute: GrnBuildRoute,
  InvoicesIdRoute: InvoicesIdRoute,
  InvoicesFromGrnsRoute: InvoicesFromGrnsRoute,
  InvoicesNewRoute: InvoicesNewRoute,
  InvoicesPaymentQueueRoute: InvoicesPaymentQueueRoute,
  PurchaseOrdersBuildRoute: PurchaseOrdersBuildRoute,
  RfqBuildRoute: RfqBuildRoute,
  RfqNewRoute: RfqNewRoute,
  SettingsApprovalsRoute: SettingsApprovalsRoute,
  SettingsDepartmentsRoute: SettingsDepartmentsRoute,
  SettingsEmailRoute: SettingsEmailRoute,
  SettingsLocationsRoute: SettingsLocationsRoute,
  SettingsMatchPolicyRoute: SettingsMatchPolicyRoute,
  SettingsRolesRoute: SettingsRolesRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
